import React, { ReactNode, ReactNodeArray } from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import LostOrStolenBlockData from '../../../Models/Content/LostOrStolenBlockData';
import LostOrStolen from './LostOrStolen.js';

export default class LostOrStolenBlock extends EpiComponent<LostOrStolenBlockData> {
  public render(): null | ReactNode | ReactNodeArray {
    return <LostOrStolen contentData={this.props.data} context={this.getContext()} />;
  }
}
